import { TableCell, TableRow } from "@mui/material";
import moment from "moment";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { savePdfUrls } from "Redux/Actions/Index";

interface IApprovedInsuranceProviderRow {
  id: string;
  providerName: string;
  providerCode?: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  phoneNumber: string;
  status: string;
  approvedBy: string;
  approvedDate: string;
  file?: string;
  fileName?: string;
}

function ApprovedInsuranceProviderRow(props: {
  row: IApprovedInsuranceProviderRow;
}) {
  const { row } = props;
  const dispatch = useDispatch();

  const formatDateTime = (dateString: string) => {
    if (!dateString) return "-";
    return moment(dateString).format("MM:DD:YYYY & HH:mm:ss");
  };

  return (
    <>
      <TableRow>
        <TableCell id={`RowProviderName_${row.id}`}>
          {row.providerName}
        </TableCell>
        <TableCell id={`RowProviderCode_${row.id}`}>
          {row.providerCode || "-"}
        </TableCell>
        <TableCell id={`RowAddress_${row.id}`}>{row.address}</TableCell>
        <TableCell id={`RowCity_${row.id}`}>{row.city}</TableCell>
        <TableCell id={`RowState_${row.id}`}>{row.state}</TableCell>
        <TableCell id={`RowZipCode_${row.id}`}>{row.zipCode}</TableCell>
        <TableCell id={`RowPhoneNumber_${row.id}`}>{row.phoneNumber || "-"}</TableCell>
        <TableCell id={`RowStatus_${row.id}`}>{row.status}</TableCell>
        <TableCell id={`RowApprovedBy_${row.id}`}>
          {row.approvedBy || "-"}
        </TableCell>
        <TableCell id={`RowApprovedDate_${row.id}`}>
          {formatDateTime(row.approvedDate)}
        </TableCell>
        <TableCell id={`RowFile_${row.id}`}>
          <div className="d-flex justify-content-center">
            {row.file ? (
              <Link to={`/docs-viewer`} target="_blank">
                <i
                  className="bi bi-file-earmark-pdf text-danger fa-2x cursor-pointer"
                  onClick={() => {
                    dispatch(savePdfUrls(row.file));
                  }}
                ></i>
              </Link>
            ) : (
              "-"
            )}
          </div>
        </TableCell>
      </TableRow>
    </>
  );
}

export default ApprovedInsuranceProviderRow;



